import React, { useRef } from 'react';

type FeeNoticeRichTextareaProps = {
  value: string;
  onChange: (value: string) => void;
  rows?: number;
  placeholder?: string;
};

function wrapSelection(
  textarea: HTMLTextAreaElement,
  before: string,
  after: string,
): { value: string; selectionStart: number; selectionEnd: number } {
  const start = textarea.selectionStart;
  const end = textarea.selectionEnd;
  const current = textarea.value;
  const selected = current.slice(start, end) || 'văn bản';
  const value = current.slice(0, start) + before + selected + after + current.slice(end);
  const selectionStart = start + before.length;
  const selectionEnd = selectionStart + selected.length;
  return { value, selectionStart, selectionEnd };
}

export const FeeNoticeRichTextarea: React.FC<FeeNoticeRichTextareaProps> = ({
  value,
  onChange,
  rows = 3,
  placeholder,
}) => {
  const ref = useRef<HTMLTextAreaElement>(null);

  const applyWrap = (before: string, after: string) => {
    const el = ref.current;
    if (!el) return;
    const next = wrapSelection(el, before, after);
    onChange(next.value);
    requestAnimationFrame(() => {
      el.focus();
      el.setSelectionRange(next.selectionStart, next.selectionEnd);
    });
  };

  return (
    <div className="space-y-1">
      <div className="flex flex-wrap gap-1">
        <button
          type="button"
          className="px-2 py-0.5 text-xs font-semibold border border-gray-300 rounded hover:bg-gray-50"
          onClick={() => applyWrap('**', '**')}
          title="In đậm"
        >
          B
        </button>
        <button
          type="button"
          className="px-2 py-0.5 text-xs italic border border-gray-300 rounded hover:bg-gray-50"
          onClick={() => applyWrap('*', '*')}
          title="In nghiêng"
        >
          I
        </button>
        <button
          type="button"
          className="px-2 py-0.5 text-xs underline border border-gray-300 rounded hover:bg-gray-50"
          onClick={() => applyWrap('__', '__')}
          title="Gạch chân"
        >
          U
        </button>
      </div>
      <textarea
        ref={ref}
        rows={rows}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg font-mono text-sm"
      />
      <p className="text-xs text-gray-500">
        **in đậm**, *nghiêng*, __gạch chân__. Xuống dòng được giữ trên PDF.
      </p>
    </div>
  );
};

export default FeeNoticeRichTextarea;
